import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Cms, ICarDetails } from '@impact/data';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { GlobalDataService } from '../core/global-data.service';
import { UsedCarFinancingTypes, UsedCarPageSections } from './used-car.models';

@Injectable({
    providedIn: 'root',
})
export class UsedCarService {
    private carDetailsSubject$ = new ReplaySubject<ICarDetails>(1);
    private pageDataSubject$ = new BehaviorSubject<Cms.UsedCarDetailsPage | undefined>(undefined);
    private financingTypeSubject$ = new BehaviorSubject<UsedCarFinancingTypes>(UsedCarFinancingTypes.Loan);
    carDetails$ = this.carDetailsSubject$.asObservable();
    pageData$ = this.pageDataSubject$.asObservable();
    financingType$ = this.financingTypeSubject$.asObservable();

    constructor(
        public location: Location,
        private globalDataService: GlobalDataService
    ) {}

    getHashUrl(anchor: UsedCarPageSections | string) {
        return `${this.location.path()}#${anchor}`;
    }

    getBanks() {
        return this.globalDataService.getBanks().pipe(map((data) => data.children));
    }

    setCarDetails(details: ICarDetails) {
        this.carDetailsSubject$.next(details);
    }

    setPageData(data: Cms.UsedCarDetailsPage) {
        this.pageDataSubject$.next(data);
    }

    setFinancingType(type: UsedCarFinancingTypes) {
        this.financingTypeSubject$.next(type);
    }
}
